<template>
  <b-card>
    <h3>
      {{ boxTitle || $gettext('Comments') }}
      <b-button size="sm" style="padding: 0.1rem 1rem;" @click.prevent="newComment = null" v-b-modal.modalAddComment v-show="addConditionLocal" v-translate>
        Add a comment
      </b-button>
      <b-button size="sm" style="padding: 0.1rem 1rem;" variant="danger" @click.prevent="deleteComments" v-show="payloadField && payloadField[this.commentFieldName] && deleteConditionLocal" v-translate>
        Delete ALL comments
      </b-button>
    </h3>
    <div v-if="payloadField && payloadField[this.commentFieldName]" style="height: 150px; overflow-y: auto">
      <div v-html="$options.filters.brize(payloadField[this.commentFieldName])"></div>
    </div>
    <div v-else>
      <translate>No comments yet.</translate>
    </div>
    <b-modal ref="modalAddComment" id="modalAddComment" hide-footer>
      <div slot="modal-title" v-translate>Add a comment</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <form @submit.stop.prevent="addComment">
        <b-row>
          <b-col cols="12" class="form-group">
            <b-form-textarea v-model="newComment" required></b-form-textarea>
          </b-col>
          <div class="form-group col-12 form-actions">
            <b-button variant="primary" type="submit" :disabled="!newComment" v-translate>
              Send Comment
            </b-button>
            <b-button variant="secondary" @click.prevent="$refs.modalAddComment.hide()" v-translate>
              Cancel
            </b-button>
          </div>
        </b-row>
      </form>
    </b-modal>
  </b-card>
</template>

<script>
export default {
  name: 'CommentsBoxSingleField',
  props: {
    boxTitle: {
      type: String,
      default: null
    },
    commentFieldName: {
      type: String,
      default: null
    },
    payloadFieldName: {
      type: String,
      default: null
    },
    payloadField: {
      type: Object,
      default: null
    },
    endpoint: {
      type: String,
      default: null
    },
    addCondition: {
      type: Boolean,
      default: false
    },
    deleteCondition: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      newComment: null,
      addConditionLocal: null,
      deleteConditionLocal: null
    }
  },
  watch: {
    addCondition(val) {
      this.addConditionLocal = val
    },
    deleteCondition(val) {
      this.deleteConditionLocal = val
    }
  },
  mounted() {
    this.addConditionLocal = this.addCondition || (this.isSuperAdmin || this.isAdmin || this.isOperatorSupervisor)
    this.deleteConditionLocal = this.deleteCondition || (this.isSuperAdmin || this.isAdmin)
  },
  methods: {
    addComment() {
      let payload
      if (this.payloadFieldName) {
        this.payloadField[this.commentFieldName] = this.$store.getters.profile.name + ' (' + this.moment.utc().tz(this.$tz).format('L LT') + ' ' + (!this.$cookies.get('bypassCountry') ? window.country : 'UTC') + ')\n' + this.newComment + '\n\n' + (this.payloadField[this.commentFieldName] || '')
        payload = {
          [this.payloadFieldName]: this.payloadField
        }
      } else {
        payload = {
          [this.commentFieldName]: this.$store.getters.profile.name + ' (' + this.moment.utc().tz(this.$tz).format('L LT') + ' ' + (!this.$cookies.get('bypassCountry') ? window.country : 'UTC') + ')\n' + this.newComment + '\n\n' + (this.payloadField[this.commentFieldName] || '')
        }
      }
      this.$http.patch(this.endpoint, payload)
        .then(() => {
          this.$emit('success', true)
          this.$refs.modalAddComment.hide()
        })
    },
    deleteComments() {
      if (
        confirm(this.$gettext('Are you sure you want to DELETE ALL the comments?\n\n***WARNING: THIS CAN NOT BE UNDONE***'))
      ) {
        let payload
        if (this.payloadFieldName) {
          this.payloadField[this.commentFieldName] = null
          payload = {
            [this.payloadFieldName]: this.payloadField
          }
        } else {
          payload = {
            [this.commentFieldName]: null
          }
        }
        this.$http.patch(this.endpoint, payload)
          .then(() => {
            this.$emit('delete', true)
          })
      }
    }
  }
}
</script>
